// extracted by mini-css-extract-plugin
module.exports = {"rewards":"Rewards_rewards__pG4jp","awardList":"Rewards_awardList__YfOtM","line":"Rewards_line__5jCSo","left":"Rewards_left__62cb7","right":"Rewards_right__VzQnx"};